import type { AddressTagFilterTestIds } from 'application/components/AddressTagFilter/types';

export const VIDEO_TEMP_FF = true;

export const DATA_TEST_IDS = {
  TAG_FILTER_BUTTON: 'video_stream_bind_tag_filter_button',
  TAG_FILTER_BADGE: 'video_stream_bind_tag_filter_badge',
  TAG_FILTER_DROPDOWN: 'video_stream_bind_tag_filter_dropdown',
  TAG_FILTER_SEARCH: 'video_stream_bind_tag_filter_search',
  TAG_FILTER_EXACT_SWITCHER: 'video_stream_bind_tag_filter_exact_switcher',
  TAG_FILTER_EXACT_INFO: 'video_stream_bind_tag_filter_exact_info',
  TAG_FILTER_EXACT_TOOLTIP: 'video_stream_bind_tag_filter_exact_tooltip',
  TAG_FILTER_OPTION: (tagId: string) => `video_stream_bind_tag_filter_option_${tagId}`,
  TAG_FILTER_OPTION_CHECKBOX: (tagId: string) => `video_stream_bind_tag_filter_option_checkbox_${tagId}`,
  APPLIED_TAGS: 'video_stream_bind_applied_tags',
  APPLIED_TAGS_DIVIDER: 'video_stream_bind_applied_tags_divider',
  APPLIED_TAG_REMOVE: (tagId: string) => `video_stream_bind_applied_tag_remove_${tagId}`,
  APPLIED_TAG: (tagId: string) => `video_stream_bind_applied_tag_${tagId}`,
  APPLIED_TAGS_MORE: 'video_stream_bind_applied_tags_more',
  APPLIED_TAGS_CLEAR: 'video_stream_bind_applied_tags_clear',
  POINTS_LIST_EMPTY: 'video_stream_bind_points_empty',
} as const;

export const VIDEO_STREAM_TAG_FILTER_TEST_IDS: AddressTagFilterTestIds = {
  mainSearch: 'toolbar_input_search',
  filterButton: DATA_TEST_IDS.TAG_FILTER_BUTTON,
  filterBadge: DATA_TEST_IDS.TAG_FILTER_BADGE,
  dropdown: DATA_TEST_IDS.TAG_FILTER_DROPDOWN,
  tagSearch: DATA_TEST_IDS.TAG_FILTER_SEARCH,
  exactSwitcher: DATA_TEST_IDS.TAG_FILTER_EXACT_SWITCHER,
  exactInfo: DATA_TEST_IDS.TAG_FILTER_EXACT_INFO,
  exactTooltip: DATA_TEST_IDS.TAG_FILTER_EXACT_TOOLTIP,
  tagOption: DATA_TEST_IDS.TAG_FILTER_OPTION,
  tagOptionCheckbox: DATA_TEST_IDS.TAG_FILTER_OPTION_CHECKBOX,
  appliedTags: DATA_TEST_IDS.APPLIED_TAGS,
  appliedTag: DATA_TEST_IDS.APPLIED_TAG,
  appliedTagRemove: DATA_TEST_IDS.APPLIED_TAG_REMOVE,
  appliedTagsDivider: DATA_TEST_IDS.APPLIED_TAGS_DIVIDER,
  appliedTagsMore: DATA_TEST_IDS.APPLIED_TAGS_MORE,
  appliedTagsClear: DATA_TEST_IDS.APPLIED_TAGS_CLEAR,
};
